module.exports = __webpack_public_path__ + "static/media/4.c2c03e6c.jpg";